import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { OrderDetail } from 'domains/order';

export const getOrderDetail: QueryFunction<OrderDetail> = async ({ queryKey: [id] }) => {
  return (await api
    .get(`/reseller/order/${id}/detail?presenter=stargate&version=v2`)
    .then((resp) => resp.data)) as OrderDetail;
};
